import { ContractType } from "domain/contract";
import { useState } from "react";
import * as _ from "lodash";
import ContractSubType from "./contractSubType";
import contractService from "./contractService";
import { PaymentOption } from "domain/paymentOption";
import { DeliveryMethod } from "domain/deliveryMethod";

const getCached = _.memoize(async (contractType: ContractType, customerWillSell: boolean, cropYearId: string, paymentOption: PaymentOption, deliveryMethod: DeliveryMethod) => {
    return await contractService.listContractSubTypes(contractType, customerWillSell, cropYearId, paymentOption, deliveryMethod);
});

export default function useContractSubTypes(contractType: ContractType, customerWillSell: boolean, cropYearId: string, paymentOption: PaymentOption, deliveryMethod: DeliveryMethod): ContractSubType[] {
    
    const [subTypes, setSubTypes] = useState<ContractSubType[]>(null);

    if (subTypes == null) {
        getCached(contractType, customerWillSell, cropYearId, paymentOption, deliveryMethod).then(setSubTypes);
        return [];
    }

    return subTypes;
}